import { Component, ElementRef, OnDestroy, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { LoginService } from '../login.service';
import {TranslateService} from '@ngx-translate/core';
import { MatDialog } from '@angular/material/dialog';
import { ForgotPasswordComponent } from '../forgot-password/forgot-password.component';
import { SafeStyle,DomSanitizer } from '@angular/platform-browser';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
    standalone: false
})
export class LoginComponent implements OnInit,OnDestroy {
 @ViewChildren('codeInput') codeInputs: QueryList<ElementRef>;
 @ViewChild('otpInput') otpInput: ElementRef<HTMLInputElement>;
 
  user: string;
  pw: string;
  error: string;
  code: string;
  hidepw=true;
  typed=false;
  showLogin=false;
  currentDate = new Date();
  currentYear = this.currentDate.getFullYear();
  is2faLoading:boolean = false;
  twoFactorCode:string = '';
  showTwoFactorInput = false;
  isOtpInputFocused = false;
  countdown: number;
  canResend = false;
  clinicSearchValue:string = '';
  resendAttemptCount = 0;  
  private timerInterval: any;
  showUpdateInfoForm = false;
  showPrivacyPolicy = false;
  hasReadPolicy = false;
  isUpdateLoading = false;
  updateInfo = {
    id: '',
    phone: '',
    email: '',
    authMode: 'whatsapp' // Default to WhatsApp
  };
  showCookiePopup = false;
  showUserSelection = false;
  userSearchValue = '';
  isSelecting = false;
  private readonly COOKIE_CONSENT_KEY = 'artisan_cookie_consent';
  
  constructor(public loginService: LoginService, private translate: TranslateService,public dialog:MatDialog,private sanitizer: DomSanitizer) { 
    this.translate.use('en-US');//load tranlations for non prinouts - regular login - for now hebrew
  }

  ngOnInit() {
    this.checkCookieConsent();
    this.loginService.twoFactorRequired.subscribe(() => { // subscribes to twoFactorReqired
    this.loginService.isLoginLoading = false;
    this.loginService.loginError = '';
    this.showTwoFactorInput = true; 
    this.startResendTimer();
    // focus the first input box
    setTimeout(() => this.otpInput.nativeElement.focus(), 400);
  });

    this.loginService.updateInfoRequired.subscribe(() => { // subscribes to updateInfoRequired
      this.loginService.isLoginLoading = false;
      this.loginService.loginError = '';
      this.showUpdateInfoForm = false; // false for now (to show the privacy-pol)
      this.showPrivacyPolicy = true;
      this.hasReadPolicy = false;
      this.updateInfo = { id: '', phone: '', email: '', authMode: 'whatsapp' }; // Reset form
    });  

    this.loginService.onFailedLogin.subscribe(()=>{
    this.loginService.isLoginLoading = false;
  });
  }
  ngOnDestroy() {
    if (this.timerInterval) {
      clearInterval(this.timerInterval);
    }
  }

  checkCookieConsent() {
  if (!localStorage.getItem(this.COOKIE_CONSENT_KEY)) {
      this.showCookiePopup = true;
    }  
  }

  handleConsent(consent: 'allowed' | 'essential'): void {
    localStorage.setItem(this.COOKIE_CONSENT_KEY, consent);
    this.showCookiePopup = false;
  }

 checkLogin(){
    if(!this.user || !this.pw) {
      return this.loginService.loginError = 'Username or password is empty';
    }  
    // this.loginService.totpVerify = true;
    if(! this.loginService.getCode)
    this.loginService.login(this.user,this.pw);
  else
    this.loginService.sendCode(this.code);
  }
  
  clean(){
    try{
      this.user = this.user.replace(/[^\x00-\x7F]+/, '')
      this.pw = this.pw.replace(/[^\x00-\x7F]+/, '')
    }
    catch{}
  }

  // setClinic(index:number){
  //   this.loginService.setClinic(index);
  // }
  async setClinic(clinic: any) {
  if (this.isSelecting) return;
  this.isSelecting = true;

  try {
    const Index = this.loginService.clinicOptions.indexOf(clinic);
    if (Index === -1) {
        console.error("Clinic not found in main list");
        return;
    }
    const finished = await this.loginService.setClinic(Index);
    if (!finished) {
      this.showUserSelection = true;
      this.userSearchValue = '';
    }
  } catch (e) {
    console.error(e);
  } finally {
    this.isSelecting = false;
  }
}

  userSearch() {
    const term = this.userSearchValue.toLowerCase().trim();
    if (!term) {
        this.loginService.filteredUserSearch = this.loginService.usersList;
        return;
    }
    this.loginService.filteredUserSearch = this.loginService.usersList.filter(u => 
        (u.Name || '').toLowerCase().includes(term) || 
        (u.UserName || '').toLowerCase().includes(term)
    );
  }

  selectUser(user: any) {
    if (this.isSelecting) return;
    this.isSelecting = true;
    
    this.loginService.impersonateUser(user.UID);
    
    setTimeout(() => {
        this.isSelecting = false;
        this.showUserSelection = false;
    }, 500);
  }
  viewonly(){

  }
    openForgotPasswordDialog(): void {
    this.dialog.open(ForgotPasswordComponent, {
      position: {top: '10vh'},
      width: '448px',
      maxWidth: '94vw',
      panelClass: 'custom-dialog-container',
      autoFocus: 'first-tabbable',
      restoreFocus: true,
    });
  }

  tryAlternate2FA(): void {
    const method = this.loginService.twoFaAlternateMethod;
    if (method) {
      this.loginService.retry2FAWith(method);
    }
  }
  onOtpFocus(): void {
    this.isOtpInputFocused = true;
  }

  onOtpBlur(): void {
    this.isOtpInputFocused = false;
  }

  isCursorVisible(index: number): boolean {
    return this.isOtpInputFocused && index === this.twoFactorCode.length && index < 6;
  }

  onCodeInputChange(): void {
    if (this.twoFactorCode.length === 6) {
      this.verifyTwoFactorCode();
    } else {
      this.is2faLoading = false;
      this.loginService.loginError = '';
    }
  }

  onCodePaste(event: ClipboardEvent) {
    event.preventDefault();
    const pastedData = event.clipboardData?.getData('text').trim();
    const sixDigitCodeRegex = /^\d{6}$/;

    if (pastedData && sixDigitCodeRegex.test(pastedData)) {
      // Paste will work only Incase the user pasted 6 digit string
      this.twoFactorCode = pastedData;
    }
  }

  verifyTwoFactorCode() {
    // Now we use the string directly
    if (this.twoFactorCode.length === 6 && !this.is2faLoading) {
      this.is2faLoading = true;
      this.loginService.completeLoginWith2FA(this.twoFactorCode)
      .finally(()=> {
        this.is2faLoading= false;
      });
    }
  }

  goBackToLogin() {
    this.showTwoFactorInput = false;
    this.loginService.loginError = ''; // Clear any displayed errors
    this.showUpdateInfoForm = false; // Clear Update Info Form
    this.showPrivacyPolicy = false; // closes privacy-policy
    this.showUpdateInfoForm = false; // ?
    this.hasReadPolicy = false; // Resets the button to be dark again    
    this.twoFactorCode = ''; // Reset the code input fields
    this.showUserSelection = false; // Resets User selection(ArtisanSupport)
    this.userSearchValue = ''; // Resets User Search Val(ArtisanSupport)
    this.user = ''; // Clear old user credentials
    this.pw = '';
    if(this.loginService.clinicOptions) {
      delete this.loginService.clinicOptions;
      this.loginService.Logout();
    }    
  }

  startResendTimer(): void {
    this.canResend = false;
    this.countdown = 30;
    if (this.timerInterval) {
      clearInterval(this.timerInterval);
    }

    this.timerInterval = setInterval(() => {
      if (this.countdown > 0) {
        this.countdown--;
      } else {
        this.canResend = true;
        clearInterval(this.timerInterval);
      }
    }, 1000);
  }

  resendCode(): void {
    if (!this.canResend) return;
    this.canResend = false;
    this.resendAttemptCount++;
    // Re-POSTing the login makes the server issue a fresh code. (Was getotp(), which first asked
    // the retired /api/login/getTOTPSet whether to open the dead TOTP box.)
    this.checkLogin();
     this.otpInput.nativeElement.focus();
     this.startResendTimer();
  }  
  clinicSearch() {
  const searchparam = this.clinicSearchValue.toLowerCase().trim();  

   if(!searchparam) {
    this.loginService.filteredClinicSearch = this.loginService.clinicOptions;
   }

   this.loginService.filteredClinicSearch = this.loginService.clinicOptions.filter(clinic => {
    return clinic.ClinicTitle.toLowerCase().trim().includes(searchparam);
   })
  }

  sendSelectedCode(method: 'sms'| 'whatsapp'): void {
    if (!this.canResend) return;

    this.loginService.requestResend2FACode(method).subscribe();
    this.otpInput.nativeElement.focus();
    this.startResendTimer();
  }
  
  getBackgroundImage(): SafeStyle {
    // Function that decides which Login background load(this is to ensure temporary background)
    const imageUrl = this.loginService.altSplashPage
      ? this.loginService.altSplashPage
      : 'assets/bg/login.jpg';

    return this.sanitizer.bypassSecurityTrustStyle(`url(${imageUrl})`);
  }
  clearError(): void {
    this.loginService.loginError = '';
  }    
  submitUpdateInfo(): void {
    this.isUpdateLoading = true;
    this.loginService.loginError = '';

    // Validation
    if (!this.updateInfo.id || !this.updateInfo.phone || !this.updateInfo.email) {
      this.loginService.loginError = 'Please fill in all required fields.';
      this.isUpdateLoading = false;
      return;
    }

    // Phone Validation
    const phoneRegex = /^05\d{8}$/;
    if (!phoneRegex.test(this.updateInfo.phone)) {
      this.loginService.loginError = 'Please enter a valid phone number (e.g., 05XXXXXXXX).';
      this.isUpdateLoading = false;
      return;
    }

    // Basic Email Validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(this.updateInfo.email)) {
         this.loginService.loginError = 'Please enter a valid email address.';
         this.isUpdateLoading = false;
         return;
    }
    // End Validation 
  
this.loginService.updateUserInfoAndProceed(this.updateInfo)
      .then(() => {
        // --- SUCCESS ---
        this.isUpdateLoading = false;
        this.showUpdateInfoForm = false;
      })
      .catch((err) => {
        // --- FAILURE ---
        console.error('Update info failed:', err);
        this.isUpdateLoading = false;
      });
  }

  onPolicyScroll(event: any): void {
    if (this.hasReadPolicy) return; // Don't run check if already true

    const target = event.target;
    // show button
    if (target.scrollHeight - target.scrollTop <= target.clientHeight + 10) {
      this.hasReadPolicy = true;
    }
  }

  // When the user clicks "Continue" after reading the policy
  acceptPolicy(): void {
    if (this.hasReadPolicy) {
      this.showPrivacyPolicy = false;
      this.showUpdateInfoForm = true;
      this.loginService.loginError = ''; // Clear any errors
    }
  }

  downloadPolicy(): void {
    
    const link = document.createElement('a');
    
    link.href = 'assets/documents/privacy-policy.docx'; 

    link.download = 'ArtisanSonics-Privacy-Policy.docx';

    link.setAttribute('target', '_blank');
    
    document.body.appendChild(link);
    link.click();

    document.body.removeChild(link);
  }  
}
